import React from 'react';
import { Link } from 'react-router-dom';
import { COMMUNITY_ENABLED } from '../../config/featureFlags';
import './Header.css';

interface HeaderProps {
  onLoginClick?: () => void;
  user?: any;
  onLogout?: () => void;
  onDashboardClick?: () => void;
  onPrivateCircleClick?: () => void;
  hideDashboardAndLogoutButtons?: boolean;
  isLoggingOut?: boolean;
}

const Header: React.FC<HeaderProps> = ({ 
  onLoginClick, 
  user, 
  onLogout, 
  onDashboardClick,
  onPrivateCircleClick,
  hideDashboardAndLogoutButtons,
  isLoggingOut = false
}) => {
  return (
    <nav className="navbar">
      <div className="logo-container">
        <div className="logo-placeholder">
          <div className="logo-chart">
            <div className="logo-chart-bar"></div>
          </div>
        </div>
        <a href="/" className="brand-name">datacircle</a>
      </div>
      <div className="nav-buttons">
        <Link to="/demo" className="nav-item" id="navDemoButton">Демо-версия</Link>
        {COMMUNITY_ENABLED && (
          onPrivateCircleClick ? (
            <button type="button" className="nav-item nav-item--circle" onClick={onPrivateCircleClick}>
              Сообщество
              <span className="nav-item__badge">✦ NEW</span>
            </button>
          ) : (
            <Link to="/private-circle" className="nav-item nav-item--circle">
              Сообщество
              <span className="nav-item__badge">✦ NEW</span>
            </Link>
          )
        )}
        {user && !hideDashboardAndLogoutButtons ? (
          <>
            <button className="nav-item" onClick={onDashboardClick}>
              Личный кабинет
            </button>
            <button className="nav-item nav-item--logout" onClick={() => onLogout?.()} disabled={isLoggingOut}>
              Выйти
            </button>
          </>
        ) : !user ? (
          <button className="nav-item" onClick={onLoginClick}>
            Авторизация
          </button>
        ) : null}
      </div>
    </nav>
  );
};

export default Header;
